<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    eager
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="location-check-dialog"
  >
    <!-- dialog common header -->
    <popup-header v-on:clickClose="closeModal()"></popup-header>

    <v-container class="pa-0">
      <!-- 0. 모달 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="icon-title word-type d-flex align-center py-4">
          <icon-map :width="16" :height="20"></icon-map>출퇴근 위치 확인
        </v-col>
      </v-row>

      <v-row class="ma-0 overflow-y-auto" :style="scrollViewStyle">
        <!-- 1. 지도 -->
        <v-col cols="12" class="pa-0">
          <map-frame v-if="mapFlag"></map-frame>
        </v-col>

        <!-- 2. 위치정보 저장안내 -->
        <v-col v-if="IS_GPS_MAP_USE" cols="12" class="px-6 py-0 mt-4">
          <!-- gps&map : 개인위치정보 저장되지 않음을 안내 -->
          <div class="location-info-box">
            <span class="icon">📍</span>
            <strong>위치정보는 별도로 저장되지 않습니다!</strong>
          </div>
        </v-col>

        <!-- pass option : 위치정보 수집 동의 체크박스 -->
        <v-col v-else cols="12" class="px-6 py-0 mt-6">
          <v-checkbox
            v-model="isLocationConsent"
            class="ma-0 pa-0"
            :label="$t('위치정보 수집·이용 및 저장에 동의합니다.')"
            color="#087ef7"
          />
          <span class="desc">
            위치정보는 출퇴근 가능 여부 확인 및 기록 생성에만 사용됩니다.
          </span>
        </v-col>

        <!-- 3. 사용자를 위한 안내(위치정보 확인이 불가능 할 경우) -->
        <v-col cols="12" class="px-6 py-0 mt-3 mb-12">
          <div class="card-box light-gray">
            <span class="title">
              <span class="icon-wrap">
                <v-icon class="point-blue">mdi-map-marker</v-icon>
              </span>
              현재 위치를 확인할 수 없을때 ?
            </span>

            <ul class="noti-list pa-0 mt-3">
              <li>
                앱의 <span class="point-blue">위치 권한 설정</span>을 확인하고,
                <span class="point-blue">네트워크 연결 상태</span>를
                점검해주세요.
              </li>
              <li>오류가 반복되면 앱을 재시작해 주세요.</li>
              <li>계속 발생할 시 현재 화면을 담당자에게 공유해 주세요.</li>
            </ul>
          </div>
        </v-col>
      </v-row>

      <!-- 4. 출퇴근처리 버튼(고정) -->
      <v-bottom-navigation
        fixed
        scroll-threshold="500"
        height="96"
        style="box-shadow: none"
      >
        <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
          <v-col cols="12">
            <v-btn
              block
              elevation="0"
              class="btn-fixed"
              color="primary"
              :disabled="
                !(IS_GPS_MAP_USE && GET_LBS_FLAG) &&
                !(!IS_GPS_MAP_USE && isLocationConsent)
              "
              @click="clickInOutBtn()"
            >
              <span class="white--text">
                {{ pendingGubun === '1' ? '출근' : '퇴근' }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-bottom-navigation>
    </v-container>
  </v-dialog>
</template>

<script>
/* 현재위치 체크 모달 */
import { mapGetters } from 'vuex';
import PopupHeader from '@/components/common/PopupHeader.vue';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import MapFrame from '@/components/common/MapFrame.vue';
import IconMap from '@/assets/customIcon/IconMap.vue';

export default {
  mixins: [dialogMixin],

  props: {
    pendingGubun: { type: String, required: true },
  },

  data: () => ({
    modalName: 'location_check',
    mapFlag: false,

    isLocationConsent: false, // 위치정보 수집 동의 여부
  }),

  watch: {
    dialog(val) {
      if (val) {
        // * Modal opened
        this.mapFlag = true;
      } else {
        // * Modal closed
        this.mapFlag = false;
        this.isLocationConsent = false; // 위치정보 수집 동의 초기화
      }
    },
  },

  computed: {
    ...mapGetters(['GET_CURRENT_LOCATION', 'IS_GPS_MAP_USE', 'GET_LBS_FLAG']),

    /* 버튼유무에 따른 스크롤 높이 제어 */
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.vt_header_title_button
      }px`;
    },
  },

  methods: {
    clickInOutBtn() {
      // * 위치정보 수집 동의 체크
      if (!this.IS_GPS_MAP_USE && !this.isLocationConsent) {
        alert(
          '위치정보 수집·이용 및 저장에 동의하셔야 출퇴근 처리가 가능합니다.',
        );
        return;
      }

      // * 기본 출퇴근처리
      this.$emit('saveTimecardReq');
      this.closeModal();
    },
  },

  components: {
    PopupHeader,
    MapFrame,
    IconMap,
  },
};
</script>

<style scoped lang="scss">
// _locationCheckDialog.scss
</style>
